<template>
  <div>
    <dialog-detalhe-tarefa
      v-if="dialogDetalheTarefa"
      :bdgd="bdgd"
      :dialog.sync="dialogDetalheTarefa"
      :erro="erroSelecionado"
      :modo-administrativo="modoAdministrativo"
      @executada="$emit('tarefa-executada', $event)"
    />

    <div v-if="!entidades.length" class="align-center d-flex justify-center tabela-vazia">
      Nenhum erro encontrado para os filtros selecionados.
    </div>

    <v-expansion-panels v-else v-model="panel" class="entidades-panels" flat>
      <v-expansion-panel v-for="entidade in entidades" :key="entidade.entidade" class="entidade-card">
        <v-expansion-panel-header disable-icon-rotate>
          <div>
            <h3 class="ma-0">{{ entidade.entidade }}</h3>
          </div>

          <template v-slot:actions>
            <span class="align-center d-inline-flex" :style="{ color: corEntidade(entidade) }">
              <v-icon small :color="corEntidade(entidade)">
                {{ iconeEntidade(entidade) }}
              </v-icon>
            </span>
          </template>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="content-expansion-p-rel-customizado">
          <div class="erros-scroll">
            <v-data-table
              class="erros-table"
              :headers="headers"
              :items="errosFiltrados(entidade)"
              :items-per-page="-1"
              :mobile-breakpoint="0"
              hide-default-footer
            >
              <template v-if="modoAdministrativo" v-slot:[`header.selecao`]>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-checkbox
                        :disabled="!habilitados(entidade).length"
                        :indeterminate="algunsSelecionados(entidade)"
                        :input-value="todosSelecionados(entidade)"
                        class="mt-0 pt-0"
                        hide-details
                        @change="alternarTodos(entidade)"
                      />
                    </span>
                  </template>
                  <span>Marca as linhas habilitadas desta entidade, já com o filtro atual.</span>
                </v-tooltip>
              </template>

              <template v-if="modoAdministrativo" v-slot:[`item.selecao`]="{ item }">
                <v-tooltip bottom :disabled="podeEncaminhar(item)">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-checkbox
                        :disabled="!podeEncaminhar(item)"
                        :input-value="estaSelecionado(item)"
                        class="mt-0 pt-0"
                        hide-details
                        @change="alternarItem(item, $event)"
                      />
                    </span>
                  </template>
                  <span>{{ motivoCheckbox(item) }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.nome_validacao`]="{ item }">
                <v-skeleton-loader v-if="erroEstaAtualizando(item)" class="mx-2" type="text" width="180" />
                <div v-else class="align-center d-flex erro-nome">
                  <span>{{ nomeValidacao(item) }}</span>
                </div>
              </template>

              <template v-slot:[`item.campo`]="{ item }">
                <v-skeleton-loader v-if="erroEstaAtualizando(item)" type="text" width="60" />
                <div v-else class="d-flex justify-center">
                  <span>{{ item.campo || '—' }}</span>
                </div>
              </template>

              <template v-slot:[`item.status_erro`]="{ item }">
                <v-skeleton-loader v-if="erroEstaAtualizando(item)" type="text" width="80" />
                <div v-else class="d-flex justify-center">
                  <status-erro v-if="item.status_erro" :status="item.status_erro" />
                  <span v-else>—</span>
                </div>
              </template>

              <template v-slot:[`item.fluxo_escolhido`]="{ item }">
                <v-skeleton-loader v-if="erroEstaAtualizando(item)" type="text" width="100" />
                <div v-else class="d-flex justify-center">
                  <span>{{ fluxoEscolhido(item) }}</span>
                </div>
              </template>

              <template v-slot:[`item.prioridade`]="{ item }">
                <v-skeleton-loader v-if="erroEstaAtualizando(item)" type="text" width="70" />
                <div v-else class="d-flex justify-center">
                  <status-prioridade v-if="temTarefa(item)" :prioridade="item.prioridade" />
                  <span v-else>—</span>
                </div>
              </template>

              <template v-slot:[`item.responsavel`]="{ item }">
                <v-skeleton-loader v-if="erroEstaAtualizando(item)" type="avatar" />
                <div v-else class="d-flex justify-center">
                  <v-tooltip v-if="item.responsavel && item.responsavel.nome" top>
                    <template v-slot:activator="{ attrs, on }">
                      <v-avatar v-bind="attrs" color="primary" size="24" v-on="on">
                        <span class="caption white--text">{{ iniciais(item.responsavel.nome) }}</span>
                      </v-avatar>
                    </template>
                    <span>{{ item.responsavel.nome }}</span>
                  </v-tooltip>
                  <span v-else>—</span>
                </div>
              </template>

              <template v-slot:[`item.progresso`]="{ item }">
                <v-skeleton-loader v-if="erroEstaAtualizando(item)" type="text" width="110" />
                <div v-else-if="item.status_erro" class="align-center d-flex erro-progresso">
                  <v-progress-linear
                    class="erro-progresso__track"
                    :color="corProgresso(item)"
                    height="6"
                    rounded
                    :value="progressoErro(item)"
                  />
                  <span>{{ progressoErro(item) }}%</span>
                </div>
                <span v-else>—</span>
              </template>

              <template v-slot:[`item.tipo_tarefa`]="{ item }">
                <v-skeleton-loader v-if="erroEstaAtualizando(item)" type="text" width="120" />
                <v-btn
                  v-else-if="item.status_erro === 'ENCERRADO' && temTarefa(item)"
                  class="pa-0 text-none"
                  color="primary"
                  :loading="tarefaCarregandoId === tarefaId(item)"
                  min-width="0"
                  text
                  x-small
                  @click="abrirDetalheTarefa(item)"
                >
                  Não há mais tarefas
                  <v-icon class="ml-1" color="primary" size="14">mdi-open-in-new</v-icon>
                </v-btn>
                <span v-else-if="item.status_erro === 'ENCERRADO'" class="caption grey--text">Não há mais tarefas</span>
                <v-btn
                  v-else-if="podeExecutarCorrigirPrimeiro(item)"
                  class="pa-0 text-none"
                  color="primary"
                  :loading="tarefaCarregandoId === tarefaId(item)"
                  min-width="0"
                  text
                  x-small
                  @click="abrirDetalheTarefa(item)"
                >
                  Escolher fluxo
                  <v-icon class="ml-1" color="primary" size="14">mdi-open-in-new</v-icon>
                </v-btn>
                <v-btn
                  v-else-if="temTarefa(item)"
                  class="pa-0 text-none"
                  color="primary"
                  :loading="tarefaCarregandoId === tarefaId(item)"
                  min-width="0"
                  text
                  x-small
                  @click="abrirDetalheTarefa(item)"
                >
                  {{ tipoTarefa(item) }}
                  <v-icon class="ml-1" color="primary" size="14">mdi-open-in-new</v-icon>
                </v-btn>
                <span v-else>—</span>
              </template>

              <template v-slot:[`item.data_inicio`]="{ item }">
                <v-skeleton-loader v-if="erroEstaAtualizando(item)" type="text" width="75" />
                <div v-else class="d-flex justify-center">
                  <span v-if="item.data_inicio">{{ item.data_inicio | parseToDateBR }}</span>
                  <span v-else>—</span>
                </div>
              </template>

              <template v-slot:[`item.data_final`]="{ item }">
                <v-skeleton-loader v-if="erroEstaAtualizando(item)" type="text" width="75" />
                <div v-else class="d-flex justify-center">
                  <span v-if="item.data_final" :class="{ 'error--text font-weight-medium': prazoVencido(item) }">
                    {{ item.data_final | parseToDateBR }}
                  </span>
                  <span v-else>—</span>
                </div>
              </template>

              <template v-slot:[`item.data_conclusao`]="{ item }">
                <v-skeleton-loader v-if="erroEstaAtualizando(item)" type="text" width="75" />
                <div v-else class="d-flex justify-center">
                  <span v-if="item.data_conclusao">{{ item.data_conclusao | parseToDateBR }}</span>
                  <span v-else>—</span>
                </div>
              </template>

              <template v-slot:no-data>
                <div class="align-center d-flex justify-center tabela-vazia">Nenhum erro corresponde à busca.</div>
              </template>
            </v-data-table>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import DialogDetalheTarefa from './DialogDetalheTarefa.vue';
  import StatusErro, { coresStatusErro, iconesStatusErro, statusErroDominante } from './StatusErro.vue';
  import StatusPrioridade from './StatusPrioridade.vue';
  import GestaoBdgdsErrosTarefasService from '@/services/GestaoBdgdsErrosTarefasService.js';
  import { fluxosTratamentoErro, obterFluxoAtual, progressoFluxo as calcularProgressoFluxo } from './fluxosTratamentoErro.js';

  const rotulosTipoTarefa = {
    DEFINIR_ENCAMINHAMENTO: 'Definir encaminhamento',
    TRATAR_REABERTURA: 'Tratar reabertura',
    ANALISAR_ERRO: 'Analisar erro',
    CORRIGIR_ERRO: 'Corrigir erro',
    JUSTIFICAR_ERRO: 'Justificar erro',
    CORRIGIR_ORIGEM: 'Corrigir origem',
    VALIDAR_CORRECAO: 'Validar correção',
    ENCERRAR_ERRO: 'Encerrar erro'
  };

  export default {
    name: 'ResumoTesteGestaoErros',

    components: {
      DialogDetalheTarefa,
      StatusErro,
      StatusPrioridade
    },

    props: {
      bdgd: {
        type: Object,
        default: () => ({})
      },
      entidades: {
        type: Array,
        default: () => []
      },
      busca: {
        type: String,
        default: ''
      },
      erroAtualizandoId: {
        type: [Number, String],
        default: null
      },
      modoAdministrativo: {
        type: Boolean,
        default: false
      },
      selecionados: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        panel: [0],
        dialogDetalheTarefa: false,
        erroSelecionado: {},
        tarefaCarregandoId: null
      };
    },

    computed: {
      headers() {
        const colunas = [
          { text: 'Nome da validação', value: 'nome_validacao' },
          { text: 'Campos validados', value: 'campo', align: 'center' },
          {
            text: 'Fluxo escolhido',
            value: 'fluxo_escolhido',
            align: 'center',
            sort: (fluxoA, fluxoB) => this.compararTexto(fluxoA, fluxoB)
          },
          { text: 'Status do erro', value: 'status_erro', align: 'center' },
          {
            text: 'Responsável',
            value: 'responsavel',
            align: 'center',
            sort: (responsavelA, responsavelB) => this.compararTexto(responsavelA?.nome, responsavelB?.nome)
          },
          {
            text: 'Prioridade de correção',
            value: 'prioridade',
            align: 'center',
            sort: (prioridadeA, prioridadeB) => this.compararPrioridade(prioridadeA, prioridadeB)
          },
          {
            text: 'Última tarefa',
            value: 'tipo_tarefa',
            sort: (tarefaA, tarefaB) => this.compararTexto(tarefaA, tarefaB)
          },
          { text: 'Progresso do fluxo', value: 'progresso', sortable: false },
          { text: 'Data inicial', value: 'data_inicio', align: 'center' },
          { text: 'Data final', value: 'data_final', align: 'center' },
          { text: 'Conclusão', value: 'data_conclusao', align: 'center' }
        ];

        if (!this.modoAdministrativo) return colunas;

        return [{ text: '', value: 'selecao', sortable: false, width: 56 }, ...colunas];
      }
    },

    methods: {
      ultimaTarefa(erro) {
        const tarefas = this.normalizarLista(erro.tarefas);

        return tarefas.length ? tarefas[0] : null;
      },

      podeEncaminhar(erro) {
        const tarefa = this.ultimaTarefa(erro);

        return (
          erro.status_erro === 'IDENTIFICADO' &&
          tarefa?.tipo_tarefa === 'DEFINIR_ENCAMINHAMENTO' &&
          tarefa?.status_tarefa === 'PENDENTE'
        );
      },

      motivoCheckbox(erro) {
        const tarefa = this.ultimaTarefa(erro);

        if (erro.status_erro !== 'IDENTIFICADO') return 'Só erros identificados podem ser encaminhados em lote.';

        if (!tarefa || tarefa.tipo_tarefa !== 'DEFINIR_ENCAMINHAMENTO') {
          return 'A última tarefa não é definir encaminhamento.';
        }

        return 'A tarefa de encaminhamento não está pendente.';
      },

      habilitados(entidade) {
        return this.errosFiltrados(entidade).filter((erro) => this.podeEncaminhar(erro));
      },

      estaSelecionado(erro) {
        return this.selecionados.some((item) => item.id === erro.id);
      },

      todosSelecionados(entidade) {
        const habilitados = this.habilitados(entidade);

        return habilitados.length > 0 && habilitados.every((erro) => this.estaSelecionado(erro));
      },

      algunsSelecionados(entidade) {
        const habilitados = this.habilitados(entidade);
        const marcados = habilitados.filter((erro) => this.estaSelecionado(erro)).length;

        return marcados > 0 && marcados < habilitados.length;
      },

      alternarItem(erro, marcado) {
        if (!this.podeEncaminhar(erro)) return;

        const selecionados = this.selecionados.filter((item) => item.id !== erro.id);

        if (marcado) selecionados.push(erro);

        this.$emit('update:selecionados', selecionados);
      },

      alternarTodos(entidade) {
        const marcar = !this.todosSelecionados(entidade);
        const idsDaEntidade = new Set(this.habilitados(entidade).map((erro) => erro.id));
        const selecionados = this.selecionados.filter((item) => !idsDaEntidade.has(item.id));

        if (marcar) selecionados.push(...this.habilitados(entidade));

        this.$emit('update:selecionados', selecionados);
      },

      podarSelecao() {
        if (!this.modoAdministrativo || !this.selecionados.length) return;

        const visiveis = new Map(
          this.normalizarLista(this.entidades)
            .flatMap((entidade) => this.errosFiltrados(entidade))
            .filter((erro) => this.podeEncaminhar(erro))
            .map((erro) => [erro.id, erro])
        );
        const restantes = this.selecionados.filter((erro) => visiveis.has(erro.id)).map((erro) => visiveis.get(erro.id));

        if (restantes.length !== this.selecionados.length) this.$emit('update:selecionados', restantes);
      },

      compararTexto(valorA, valorB) {
        return String(valorA || '').localeCompare(String(valorB || ''), 'pt-BR', { sensitivity: 'base' });
      },

      compararPrioridade(prioridadeA, prioridadeB) {
        const pesos = { BAIXA: 1, MEDIA: 2, ALTA: 3, URGENTE: 4 };

        return (pesos[prioridadeA] || 0) - (pesos[prioridadeB] || 0);
      },

      normalizarLista(valor) {
        return Array.isArray(valor) ? valor : [];
      },

      iniciais(nome) {
        return String(nome || '?')
          .split(' ')
          .filter(Boolean)
          .slice(0, 2)
          .map((parte) => parte[0])
          .join('')
          .toUpperCase();
      },

      nomeValidacao(erro) {
        const tipoOcorrencia = erro.tipo_ocorrencia || '';
        const nomeValidacao = erro.nome_validacao || '';

        if (tipoOcorrencia && nomeValidacao) return `${tipoOcorrencia} :: ${nomeValidacao}`;

        return tipoOcorrencia || nomeValidacao || '—';
      },

      errosFiltrados(entidade) {
        const termo = this.busca.trim().toLowerCase();

        return this.normalizarLista(entidade.erros)
          .filter((erro) => {
            if (!termo) return true;

            return [erro.nome_validacao, erro.campo, erro.tipo_ocorrencia, erro.status_erro, erro.id]
              .filter((valor) => valor !== null && valor !== undefined)
              .some((valor) => String(valor).toLowerCase().includes(termo));
          })
          .map((erro) => ({
            ...erro,
            fluxo_escolhido: this.fluxoEscolhido(erro),
            tipo_tarefa: this.tipoTarefa(erro)
          }));
      },

      tipoTarefa(erro) {
        const tarefas = this.normalizarLista(erro.tarefas);

        const tipo = tarefas.length ? tarefas[0].tipo_tarefa : null;

        return rotulosTipoTarefa[tipo] || tipo || '—';
      },

      fluxoEscolhido(erro) {
        const fluxo = fluxosTratamentoErro.find((item) => item.id === obterFluxoAtual(erro));

        return fluxo ? fluxo.label : '—';
      },

      podeExecutarCorrigirPrimeiro(erro) {
        return erro.pode_executar_corrigir_primeiro === true;
      },

      erroEstaAtualizando(erro) {
        return this.erroAtualizandoId !== null && String(erro.id) === String(this.erroAtualizandoId);
      },

      temTarefa(erro) {
        return this.normalizarLista(erro.tarefas).length > 0;
      },

      async abrirDetalheTarefa(erro) {
        const tarefaId = this.tarefaId(erro);

        if (!tarefaId) {
          if (this.podeExecutarCorrigirPrimeiro(erro)) {
            this.erroSelecionado = erro;
            this.dialogDetalheTarefa = true;
          }

          return;
        }

        this.tarefaCarregandoId = tarefaId;

        try {
          const { data } = await GestaoBdgdsErrosTarefasService.buscarTarefa(tarefaId);

          this.erroSelecionado = data.data || {};
          this.dialogDetalheTarefa = true;
        } catch (error) {
          this.$toast.error('Erro ao carregar os detalhes da tarefa.', '', { position: 'topRight' });
        } finally {
          this.tarefaCarregandoId = null;
        }
      },

      tarefaId(erro) {
        const tarefas = this.normalizarLista(erro.tarefas);

        return tarefas.length ? tarefas[0].id : null;
      },

      totalErros(entidade) {
        return this.normalizarLista(entidade.erros).length;
      },

      iconeEntidade(entidade) {
        if (!this.totalErros(entidade)) return;

        const status = statusErroDominante(this.normalizarLista(entidade.erros));

        return iconesStatusErro[status] || iconesStatusErro.DESCONHECIDO;
      },

      corEntidade(entidade) {
        if (!this.totalErros(entidade)) return this.$vuetify.theme.currentTheme.success;

        const status = statusErroDominante(this.normalizarLista(entidade.erros));

        return coresStatusErro[status] || coresStatusErro.DESCONHECIDO;
      },

      progressoErro(erro) {
        return calcularProgressoFluxo(erro);
      },

      corProgresso(erro) {
        const status = String(erro.status_erro || '').toUpperCase();

        return coresStatusErro[status] || coresStatusErro.DESCONHECIDO;
      },

      prazoVencido(erro) {
        if (!erro.data_final || erro.data_conclusao) return false;

        const [ano, mes, dia] = String(erro.data_final).slice(0, 10).split('-').map(Number);

        if (!ano || !mes || !dia) return false;

        const hoje = new Date();
        const prazo = new Date(ano, mes - 1, dia);

        hoje.setHours(0, 0, 0, 0);

        return prazo < hoje;
      }
    },

    watch: {
      entidades: {
        deep: true,
        immediate: true,
        handler(entidades) {
          if (!entidades.length) this.panel = [];

          this.podarSelecao();
        }
      },
      busca() {
        this.podarSelecao();
      }
    }
  };
</script>

<style scoped>
  .entidades-panels {
    --border: #d8d8d8;
    --border-strong: #cfcfcf;
  }

  h3 {
    color: #2d2d2d;
    font-size: 13px;
    font-weight: bold;
  }

  /* Faz o conteúdo expandido ficar alinhado às bordas do item. */
  .content-expansion-p-rel-customizado ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }

  .entidade-card {
    border: 1px solid var(--border);
    border-radius: 2px !important;
    margin: 3px 0 3px 2px;
  }

  /* Tabela como continuação do accordion, não como um card interno. */
  .erros-scroll {
    height: 300px;
    max-height: 300px;
    overflow-x: auto;
    overflow-y: auto;
    scrollbar-color: #a7a7a7 #f1f1f1;
    scrollbar-width: thin;
  }

  .erros-scroll::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .erros-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .erros-scroll::-webkit-scrollbar-thumb {
    background: #a7a7a7;
    border: 2px solid #f1f1f1;
    border-radius: 4px;
  }

  .erros-scroll::-webkit-scrollbar-thumb:hover {
    background: #7d7d7d;
  }

  .erros-scroll ::v-deep .v-data-table,
  .erros-scroll ::v-deep .v-data-table__wrapper {
    background: transparent !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  .erros-scroll ::v-deep .v-data-table__wrapper {
    overflow: visible;
  }

  .erros-table {
    min-width: 780px;
  }

  .erros-table ::v-deep table thead tr th {
    color: #6f7784 !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    height: 38px;
    padding: 8px 12px !important;
    text-transform: uppercase;
  }

  /* Linhas internas mais finas que os divisores estruturais. */
  .erros-table ::v-deep table tbody tr td {
    border-bottom: 1px solid #e4e4e4 !important;
    color: #424a58;
    font-size: 12px;
    height: 38px;
    padding: 7px 10px !important;
  }

  .erros-table ::v-deep table tbody tr:last-child td {
    border-bottom: 0 !important;
  }

  .erro-nome {
    align-items: center;
    display: flex;
    gap: 9px;
    min-width: 0;
  }

  .erro-nome span:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .erro-progresso {
    align-items: center;
    display: flex;
    font-size: 11px;
    gap: 8px;
    width: 132px;
  }

  .erro-progresso__track {
    background: #eceef1;
    border-radius: 999px;
    height: 6px;
    overflow: hidden;
  }

  .tabela-vazia {
    align-items: center;
    color: #8a93a1;
    display: flex;
    font-size: 13px;
    justify-content: center;
    min-height: 90px;
    text-align: center;
  }
</style>
